'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ContactDetailController = function () {
    /* @ngInject */
    function ContactDetailController($scope, $state, $stateParams, ApiContacts, ApiCampaigns, ApiTeam, ApiUser, $ionicLoading, $q, MessageBox, $ionicPopup, $filter) {
        _classCallCheck(this, ContactDetailController);

        this.$ionicLoading = $ionicLoading;
        this.$state = $state;
        this.ApiCampaigns = ApiCampaigns;
        this.ApiContacts = ApiContacts;
        this.ApiTeam = ApiTeam;
        this.ApiUser = ApiUser;
        this.MessageBox = MessageBox;

        this.contactId = $stateParams.contactId;
        this.campaigns = [];
        this.isCustomerContact = $stateParams.isCustomerContact;
        this.loading = [];
        this.$ionicPopup = $ionicPopup;
        this.$filter = $filter;
        this.advindaCount = $stateParams.advindaCount;
        this.customCount = $stateParams.customCount;
        this.preSelectedCampaignIds = [];
        this.translationVisible = false;
        this.addInfoVisible = false;
        this.contact = {};
    }

    _createClass(ContactDetailController, [{
        key: 'init',
        value: function init() {
            var _this = this;

            this.$ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>'
            });
            this.getContact();
            // Load contact from database

            this.ApiContacts.getContactExtensionIds(this.contactId, { 'isCustomerContact': this.isCustomerContact }).then(function (res) {
                if (res) {
                    _this.taskParameters = { contactExtensionIds: res, contactId: _this.contactId, 'isCustomerContact': _this.isCustomerContact };
                } else {
                    _this.taskParameters = { contactExtensionIds: [_this.contactId], contactId: _this.contactId, 'isCustomerContact': _this.isCustomerContact };
                }
                _this.$ionicLoading.hide();
            }).catch(function () {
                _this.$ionicLoading.hide();
            });

            // Load campaigns from database
            this.ApiCampaigns.getCampaignsMinimal().then(function (res) {
                _this.campaigns = res;
            }).catch(function () {
                _this.$ionicLoading.hide();
            });

            this.ApiUser.getUser().then(function (res) {
                if (typeof res != 'undefined') {
                    _this.userGroupId = res.groupId;
                }
            });

            this.getPreSelectedCampaignIds();
            this.getTeams();
        }
    }, {
        key: 'getContact',
        value: function getContact() {
            var _this2 = this;

            this.ApiContacts.getContact(this.contactId, { 'isCustomerContact': this.isCustomerContact }).then(function (res) {
                _this2.contact = res;
                _this2.contact.contactInfo.contact.additionalInformation = !_this2.isCustomerContact && _this2.contact.contactInfo.advindaContactAdditionalInfo ? _this2.contact.contactInfo.advindaContactAdditionalInfo.additionalInfo : _this2.contact.contactInfo.contact.additionalInformation;

                _this2.isAddressVisible = _this2.contact.contactInfo.contact.mailingStreet || _this2.contact.contactInfo.contact.mailingPostalCode || _this2.contact.contactInfo.contact.mailingCity || _this2.contact.contactInfo.contact.mailingState || _this2.contact.contactInfo.contact.mailingCountry;
                _this2.isAdditionalAddressVisible = _this2.contact.contactInfo.contact.additionalAddress || _this2.contact.contactInfo.contact.additionalZip || _this2.contact.contactInfo.contact.additionalState || _this2.contact.contactInfo.contact.additionalCountry;
                _this2.isAddressTranslationVisible = _this2.contact.contactInfo.contact.countryTranslated || _this2.contact.contactInfo.contact.stateTranslated || _this2.contact.contactInfo.contact.cityTranslated || _this2.contact.contactInfo.contact.zipTranslated || _this2.contact.contactInfo.contact.addressTranslated;

                _this2.isContactInfoSectionVisible = _this2.contact.contactInfo.contact.phone || _this2.contact.contactInfo.contact.otherPhone || _this2.contact.contactInfo.contact.mobile || _this2.contact.contactInfo.contact.privatePhoneNumber || _this2.contact.contactInfo.contact.fax || _this2.contact.contactInfo.contact.alternativeEmail || _this2.contact.contactInfo.contact.email || _this2.contact.contactInfo.contact.additionalInformation;

                _this2.isBuisnessCardVisible = _this2.contact.contactInfo.contact.businessCardInformation || _this2.contact.contactInfo.contact.businessCardInformationReceivedDate || _this2.contact.contactInfo.contact.businessCardInformationLastUpdatedDate;

                _this2.hideLoading();
            }).catch(function () {
                _this2.$ionicLoading.hide();
            });
        }
    }, {
        key: 'showLoading',
        value: function showLoading() {
            this.loading.push(1);
            this.$ionicLoading.show({ template: '<spinner-advinda></spinner-advinda>' });
        }
    }, {
        key: 'hideLoading',
        value: function hideLoading() {
            this.loading.pop();
            if (this.loading.length === 0) this.$ionicLoading.hide();
        }
    }, {
        key: 'promptContactDelete',
        value: function promptContactDelete($event) {
            var _this3 = this;

            $event.preventDefault();
            var dialogResult = this.$ionicPopup.confirm({
                title: this.$filter('translate')('DELETE_CONTACT'),
                template: this.$filter('translate')('DELETE_CONTACT_PROMPT')
            });

            dialogResult.then(function (res) {
                if (res) {
                    _this3.deleteContact(_this3.contact);
                }
            });
        }
    }, {
        key: 'deleteContact',
        value: function deleteContact(contact) {
            var _this4 = this;

            this.showLoading();
            this.ApiContacts.deleteContact(contact.contactInfo.contact.id).then(function (res) {
                _this4.hideLoading();
                if (res === null) {
                    _this4.$state.go('contacts', { defaultTab: 'TEAM' }, { reload: true });
                }
            }, function (error) {
                this.hideLoading();
                this.MessageBox.showFailMessage('CONTACT', 'DELETE');
            });
        }
    }, {
        key: 'getPreSelectedCampaignIds',
        value: function getPreSelectedCampaignIds() {
            var _this5 = this;

            this.ApiContacts.getCampaignIds(this.contactId, { 'isCustomerContact': this.isCustomerContact }).then(function (res) {
                _this5.preSelectedCampaignIds = res || [];
            });
        }
    }, {
        key: 'onCommentEntered',
        value: function onCommentEntered(comment) {
            var _this6 = this;

            this.showLoading();
            if (this.contact.contactInfo.advindaContactAdditionalInfo && this.contact.contactInfo.advindaContactAdditionalInfo.id) {
                this.additionalInfo = {
                    additionalInfo: comment,
                    contactId: this.contact.contactInfo.advindaContactAdditionalInfo.contactId,
                    groupId: this.contact.contactInfo.advindaContactAdditionalInfo.groupId,
                    id: this.contact.contactInfo.advindaContactAdditionalInfo.id
                };

                this.ApiContacts.putAdditionalInfo(this.additionalInfo).then(function (res) {
                    _this6.getContact();
                }, function () {
                    this.hideLoading();
                });
            } else {
                this.additionalInfo = {
                    'additionalInfo': comment,
                    'contactId': this.contactId,
                    'groupId': this.userGroupId
                };
                this.ApiContacts.postAdditionalInfo(this.additionalInfo).then(function (res) {
                    _this6.getContact();
                }, function () {
                    this.hideLoading();
                });
            }
        }
    }, {
        key: 'getTeams',
        value: function getTeams() {
            var _this7 = this;

            this.ApiTeam.getTeams().then(function (res) {
                if (typeof res != 'undefined') {
                    if (res) {
                        _this7.translationVisible = res.translationRequired;
                    }
                }
            });
        }
    }]);

    return ContactDetailController;
}();

exports.default = ContactDetailController;


/** WEBPACK FOOTER **
 ** ./src/app/components/contacts/contactDetail.controller.js
 **/